import { render, staticRenderFns } from "./jiaobanDialog.vue?vue&type=template&id=74e64428&scoped=true&"
import script from "./jiaobanDialog.vue?vue&type=script&lang=js&"
export * from "./jiaobanDialog.vue?vue&type=script&lang=js&"
import style0 from "./jiaobanDialog.vue?vue&type=style&index=0&id=74e64428&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e64428",
  null
  
)

export default component.exports